import i18n from 'i18next';

import {
  InputTypes,
  PaymentFormField,
  PaymentTypes,
} from '@cashier/cashier-model';

const CREDIT_CARD_CATEGORY_NAME = 'creditcard';

const NO_CHECKBOX_METHOD_IDS = new Set([
  'payment-iq-cryptocurrency-quickbit',
  'payment-iq-webredirect-flykk',
  'SwitchPaymentCard',
]);

export const provideTermsAgreementToggler = (
  paymentType: PaymentTypes,
  paymentMethod: {
    id: string;
    categories: { name: string }[];
  },
): PaymentFormField | null => {
  const { id, categories } = paymentMethod;

  const requiredTranslationsExists =
    !!(i18n.t('agreement.message', '') && i18n.t('agreement.link', '')) ||
    !!i18n.t('agreement.alternativeMessage', '');

  if (
    categories.some(
      (category) => category.name === CREDIT_CARD_CATEGORY_NAME,
    ) &&
    !NO_CHECKBOX_METHOD_IDS.has(id) &&
    paymentType === PaymentTypes.Deposit &&
    requiredTranslationsExists
  ) {
    return {
      name: 'termsAgreement',
      required: true,
      type: InputTypes.Checkbox,
      value: null,
      params: {
        isUiOnly: true,
      },
    };
  }

  return null;
};
